/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import React, { useState } from 'react';
import { Modal, Tabs, Alert } from 'antd';
import { useIntl } from 'react-intl';
import { OfferNotificationTab } from './OfferNotificationTab';

const { TabPane } = Tabs;

export interface OfferNotificationModalProps {
  visible: boolean;
  onClose: () => void;
  projectId: number;
  tenderId: number;
  tenderClosed: boolean;
}

export const OfferNotificationModal: React.FC<OfferNotificationModalProps> = ({
  visible,
  onClose,
  projectId,
  tenderId,
  tenderClosed,
}) => {
  const intl = useIntl();
  const [activeTab, setActiveTab] = useState<'finalize' | 'reopen'>('finalize');
  const [finalizeHasUnsavedChanges, setFinalizeHasUnsavedChanges] = useState(
    false
  );
  const [reopenHasUnsavedChanges, setReopenHasUnsavedChanges] = useState(false);

  const handleClose = () => {
    const hasAnyUnsavedChanges =
      finalizeHasUnsavedChanges || reopenHasUnsavedChanges;

    if (hasAnyUnsavedChanges) {
      Modal.confirm({
        title: intl.formatMessage({ id: 'unsaved-changes' }),
        content: intl.formatMessage({ id: 'unsaved-changes-message' }),
        okText: intl.formatMessage({ id: 'ok' }),
        cancelText: intl.formatMessage({ id: 'cancel' }),
        onOk: () => {
          onClose();
        },
      });
    } else {
      onClose();
    }
  };

  return (
    <Modal
      title={intl.formatMessage({ id: 'offer-notification-settings' })}
      visible={visible}
      onCancel={handleClose}
      footer={null}
      width={1100}
      destroyOnClose>
      <Tabs
        activeKey={activeTab}
        onChange={(key) => setActiveTab(key as 'finalize' | 'reopen')}
        style={{ marginTop: -16 }}>
        <TabPane
          tab={intl.formatMessage({ id: 'offer-notification-finalize-tab' })}
          key="finalize">
          <OfferNotificationTab
            type="finalize"
            projectId={projectId}
            tenderId={tenderId}
            tenderClosed={tenderClosed}
            onUnsavedChangesChange={(hasChanges, isInEditMode) => {
              setFinalizeHasUnsavedChanges(hasChanges && isInEditMode);
            }}
          />
        </TabPane>
        <TabPane
          tab={intl.formatMessage({ id: 'offer-notification-reopen-tab' })}
          key="reopen">
          <OfferNotificationTab
            type="reopen"
            projectId={projectId}
            tenderId={tenderId}
            tenderClosed={tenderClosed}
            onUnsavedChangesChange={(hasChanges, isInEditMode) => {
              setReopenHasUnsavedChanges(hasChanges && isInEditMode);
            }}
          />
        </TabPane>
      </Tabs>
    </Modal>
  );
};
